import script from "./Alerts.vue?vue&type=script&setup=true&lang=js"
export * from "./Alerts.vue?vue&type=script&setup=true&lang=js"

import "./Alerts.vue?vue&type=style&index=0&id=0c85924e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c85924e"]])

export default __exports__